import React, { Component } from "react";
import styles from "./App.module.scss";
import Demo from "./components/4_views/Demo/Demo";
import { getLanguage, changeLanguage } from "./helpers/translate.helper";
import LanguageSwitch from "./components/1_atoms/LanguageSwitch/LanguageSwitch";
import CookieConsent from "./components/1_atoms/CookieConsent/CookieConsent";
import Script from 'react-load-script';
class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      language: getLanguage(),
    };

    // INIT GTAG
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); }
    window.gtag('js', new Date());
    window.gtag('config', 'UA-133973078-1');
  }

  handleChangeLanguage(language) {
    if (changeLanguage(language)) {
      this.setState({
        language,
      });
    }
  }

  render() {
    const { language } = this.state;
    return (
      <div className={styles.host}>
        <CookieConsent>
          {process.env.NODE_ENV === 'production' && <Script async url="https://www.googletagmanager.com/gtag/js?id=UA-133973078-1"/>}
        </CookieConsent>
        <Demo language={language} />
        <div className={styles.language}>
          <LanguageSwitch
            selected={language}
            onSelect={this.handleChangeLanguage.bind(this)}
          />
        </div>
      </div>
    );
  }
}

export default App;
